export const DEADHEAD_ITEM_TEXT = {
	scheduleLabel: 'Schedule',
	typeLabel: 'Type:',
	crewMemberLabel: 'Crew member:',
	/**
	 * @param {string} from Origin location, already formatted.
	 * @param {string} to Destination location, already formatted.
	 */
	route: (from, to) => `${from} → ${to}`,
	/**
	 * @param {string} time Departure time, already formatted.
	 * @param {string} timezone Timezone name.
	 */
	departure: (time, timezone) => `Departure: ${time} (${timezone})`,
};
